import { useState } from "react";

import type { OwnerListing } from "../../services/listings.service";
import { getDateBasedPricingListings } from "../utils/host-hub-marketing-banners.utils";

import useHostHubOwnerListings from "./useHostHubOwnerListings";

/**
 * Handles the date based pricing banner's "Set date pricing" CTA, mirroring
 * mobile's `useSetDatePricing`: a host with one eligible space goes straight
 * to its pricing page; one with several picks a space in a dialog first.
 */
const useSetDatePricing = () => {
  const { listings } = useHostHubOwnerListings();
  const [isListingDialogOpen, setIsListingDialogOpen] = useState(false);
  const dateBasedPricingListings = getDateBasedPricingListings(listings);

  const goToListingPricing = (listing: OwnerListing) => {
    setIsListingDialogOpen(false);
    window.location.assign(`/mylistings/${listing._id}/price`);
  };

  const startSetDatePricing = () => {
    if (dateBasedPricingListings.length === 1) {
      goToListingPricing(dateBasedPricingListings[0]);
      return;
    }
    setIsListingDialogOpen(true);
  };

  const closeListingDialog = () => setIsListingDialogOpen(false);

  return {
    closeListingDialog,
    dateBasedPricingListings,
    goToListingPricing,
    isListingDialogOpen,
    startSetDatePricing,
  };
};

export default useSetDatePricing;
